import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BookOpen } from "lucide-react";
import { api, API } from "../../lib/api";
import { Timeline } from "./Timeline";

function Thumb({ b }) {
  const [err, setErr] = useState(false);
  if (b.has_cover && !err) return <img src={`${API}/books/${b.id}/cover-thumb`} alt="" onError={() => setErr(true)} className="w-full h-full object-cover" />;
  return <div className="w-full h-full flex items-center justify-center bg-gradient-to-b from-amber-900/60 to-slate-950 border border-amber-500/30"><BookOpen size={16} className="text-amber-300" /></div>;
}

export function StudioSeriesTimeline({ sid }) {
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/series/${sid}/timeline`).then((r) => setD(r.data)).catch(() => setD(null)); }, [sid]);
  if (!d || !d.books.length) return null;
  return (
    <div className="mt-5 pt-4 border-t border-slate-800">
      <p className="eyebrow mb-3">Reading order</p>
      <Timeline data={d} cover={(b) => <Thumb b={b} />} linkFor={(b) => `/app/books/${b.id}`} Wrap={Link} testId={`studio-timeline-${sid}`} />
    </div>
  );
}
